"use strict";

angular.module("internal.exams").controller("InternalExamSessionStatuses", [
    "$scope",
    "EXSessionStatus",
    "$rootScope",
    "Resource",
    "Cache",
    function($scope, EXSessionStatus, $rootScope, Resource, Cache) {
        EXSessionStatus.get().then(function(SessionStatuses) {
            $scope.SessionStatuses = SessionStatuses;
            $scope.loading = false;
        });

        $scope.columns = [
            {
                label: "Name",
                field: "name",
                link: {
                    state: "internal.exams.administrative.sessionstatus",
                    params: [
                        {
                            name: "examSessionStatusID",
                            field: "id"
                        },
                        {
                            name: "id",
                            field: "id"
                        }
                    ]
                }
            },

            {
                label: "Last Modified",
                field: "modifiedon",
                type: "datetime"
            },
            {
                label: "Modified By",
                field: "modifiedby"
            }
        ];
    }
]);
